/* eslint-disable no-useless-escape */
import cloneDeep from 'lodash/cloneDeep';
import assign from 'lodash/assign';

import { AppSettingsModule } from 'services/settings.provider';
import { DataServiceModule } from './data.service';

export const CartServiceModule = angular
    .module('app.services.data.cartService', [
        DataServiceModule,
        AppSettingsModule
    ]).factory('cartService', (
        dataService,
        settings
    ) => {
        return {
            getCart,
            getCarts,
            getLegacyCart,
            getLegacyAbandonedCarts,
            create,
            save
        };

        function getCart(cartId) {
            return dataService.get(settings.api.publicCartsREST, cartId);
        }

        function getCarts(options, returnHeaders = false) {
            const headers = null;
            return dataService.getAll(settings.api.cartsREST, options, headers, returnHeaders);
        }

        function getLegacyCart(cartId) {
            return dataService.get(settings.api.cart, cartId);
        }

        function getLegacyAbandonedCarts(options) {
            return dataService.getAll(settings.api.abandonedCartsLegacy, options);
        }

        function create(cart) {
            return dataService.create(settings.api.cart)
                .then((newCart) => {
                    if (cart) {
                        let oldCart = cloneDeep(cart);
                        delete oldCart.id;
                        delete oldCart.revision;
                        delete oldCart.createdOn;
                        delete oldCart.updatedOn;
                        assign(newCart, oldCart);
                    }
                    return newCart;
                });
        }

        function save(cart) {
            return dataService.save(settings.api.cart, cart.id, cart);
        }
    }).name;
/* eslint-enable no-useless-escape */



// WEBPACK FOOTER //
// ./src/app/services/data/carts.service.js